// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  name: __t.string(),
  description: __t.string(),
  difficulty: __t.string(),
  entryFeeCoins: __t.i64().name("entry_fee_coins"),
  maxParticipants: __t.u32().name("max_participants"),
  startsAt: __t.u64().name("starts_at"),
  endsAt: __t.u64().name("ends_at"),
  status: __t.string(),
  prizePoolCoins: __t.i64().name("prize_pool_coins"),
  prize1StItemId: __t.option(__t.u64()).name("prize_1st_item_id"),
  prize2NdItemId: __t.option(__t.u64()).name("prize_2nd_item_id"),
  prize3RdItemId: __t.option(__t.u64()).name("prize_3rd_item_id"),
  createdAt: __t.u64().name("created_at"),
});
